__webpack_require__.p = "/digitalipo-structure/";